module.exports = __webpack_public_path__ + "static/img/transportVisua.3c60153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transportVisua.png
// module id = DLBm
// module chunks = 1